var R = Object.defineProperty, j = Object.defineProperties;
var E = Object.getOwnPropertyDescriptors;
var u = Object.getOwnPropertySymbols;
var m = Object.prototype.hasOwnProperty, d = Object.prototype.propertyIsEnumerable;
var f = (t, e, n) => e in t ? R(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, p = (t, e) => {
  for (var n in e || (e = {}))
    m.call(e, n) && f(t, n, e[n]);
  if (u)
    for (var n of u(e))
      d.call(e, n) && f(t, n, e[n]);
  return t;
}, y = (t, e) => j(t, E(e));
var s = (t, e) => {
  var n = {};
  for (var r in t)
    m.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && u)
    for (var r of u(t))
      e.indexOf(r) < 0 && d.call(t, r) && (n[r] = t[r]);
  return n;
};
import { Fragment as N, useCallback as x, forwardRef as A, useState as M, useRef as O } from "react";
import { jsx as c, Fragment as g } from "react/jsx-runtime";
import { createPortal as C } from "react-dom";
import { e as F } from "./factory--gUH4vxz.js";
import { a as w } from "./use-id-DjDiWRdO.js";
function G(t) {
  return Array.isArray(t) || t === null ? !1 : typeof t == "object" ? t.type !== N : !1;
}
const I = {
  app: 100,
  modal: 200,
  popover: 300,
  overlay: 400,
  max: 9999
};
function H(t) {
  return I[t];
}
function i(t, e) {
  if (typeof t == "function")
    return t(e);
  typeof t == "object" && t !== null && "current" in t && (t.current = e);
}
function S(...t) {
  const e = /* @__PURE__ */ new Map();
  return (n) => {
    if (t.forEach((r) => {
      const o = i(r, n);
      o && e.set(r, o);
    }), e.size > 0)
      return () => {
        t.forEach((r) => {
          const o = e.get(r);
          o ? o() : i(r, null);
        }), e.clear();
      };
  };
}
function J(...t) {
  return x(S(...t), t);
}
function k(t) {
  const e = document.createElement("div");
  return e.setAttribute("data-portal", "true"), typeof t.className == "string" && e.classList.add(...t.className.split(" ").filter(Boolean)), typeof t.style == "object" && Object.assign(e.style, t.style), typeof t.id == "string" && e.setAttribute("id", t.id), e;
}
const q = {}, b = A((t, e) => {
  const l = F("Portal", q, t), { children: n, target: r } = l, o = s(l, ["children", "target"]), [P, h] = M(!1), a = O(null);
  return w(() => (h(!0), a.current = r ? typeof r == "string" ? document.querySelector(r) : r : k(o), i(e, a.current), !r && a.current && document.body.appendChild(a.current), () => {
    !r && a.current && document.body.removeChild(a.current);
  }), [r]), !P || !a.current ? null : C(/* @__PURE__ */ c(g, { children: n }), a.current);
});
b.displayName = "@mantine/core/Portal";
function v(r) {
  var o = r, { withinPortal: t = !0, children: e } = o, n = s(o, ["withinPortal", "children"]);
  return t ? /* @__PURE__ */ c(b, y(p({}, n), { children: e })) : /* @__PURE__ */ c(g, { children: e });
}
v.displayName = "@mantine/core/OptionalPortal";
export {
  v as O,
  H as g,
  G as i,
  J as u
};
